export default "__VITE_ASSET__gljPmjB4__"